import { Spin } from "antd"
import React from "react"
import { useRoutes } from "react-router-dom"
import ROUTER from "./index"
import SearchCourse from "src/pages/ANONYMOUS/SearchCourse"

// ANONYMOUS
const LoginGoogle = React.lazy(() => import("src/pages/LoginGoogle"))
const PublicRouters = React.lazy(() => import("src/pages/PublicRouters"))
const Home = React.lazy(() => import("src/pages/ANONYMOUS/Home"))
const ListCourse = React.lazy(() => import("src/pages/ANONYMOUS/ListCourse"))
const ListPost = React.lazy(() => import("src/pages/ANONYMOUS/ListPost"))
const News = React.lazy(() => import("src/pages/ANONYMOUS/News"))
const CourseDetail = React.lazy(() =>
  import("src/pages/ANONYMOUS/CourseDetail"),
)
const PostDetail = React.lazy(() => import("src/pages/ANONYMOUS/PostDetail"))
const NewsDetail = React.lazy(() => import("src/pages/ANONYMOUS/NewsDetail"))
const Search = React.lazy(() => import("src/pages/Search"))
const ListAllTeacher = React.lazy(() =>
  import("src/pages/ANONYMOUS/ListAllTeacher"),
)
const TeacherProfile = React.lazy(() =>
  import("src/pages/ANONYMOUS/TeacherProfile"),
)

const SvgViewer = React.lazy(() => import("src/pages/SvgViewer"))
const NotFound = React.lazy(() => import("src/pages/NotFound"))

// USER
const PrivateRoutes = React.lazy(() => import("src/pages/PrivateRoutes"))
const ProfileManager = React.lazy(() => import("src/pages/USER/ProfileManager"))
const LearnLesson = React.lazy(() => import("src/pages/USER/LearnLesson"))
const CardShopping = React.lazy(() => import("src/pages/USER/CardShopping"))

const Dashboard = React.lazy(() => import("src/pages/USER/Dashboard"))
// ADMIN
const RequestSupport = React.lazy(() =>
  import("src/pages/ADMIN/RequestSupport"),
)

const BannerFooter = React.lazy(() => import("src/pages/ADMIN/BannerFooter"))
const AminRoutes = React.lazy(() => import("src/pages/ADMIN/AminRoutes"))
const PostManager = React.lazy(() => import("src/pages/ADMIN/PostManager"))
const Tags = React.lazy(() => import("src/pages/ADMIN/Tags"))
const StudentsList = React.lazy(() => import("src/pages/ADMIN/Students"))
const CourseManagement = React.lazy(() => import("src/pages/ADMIN/Course"))
const StatisticsOverview = React.lazy(() =>
  import("src/pages/ADMIN/StatisticsOverview"),
)
const Statistical = React.lazy(() => import("src/pages/ADMIN/Statistical"))
const Overview = React.lazy(() => import("src/pages/ADMIN/Overview"))
const DetailCourse = React.lazy(() => import("src/pages/ADMIN/CourseDetail"))
const Exams = React.lazy(() => import("src/pages/ADMIN/Exams"))
const Questions = React.lazy(() => import("src/pages/ADMIN/Questions"))
const Position = React.lazy(() => import("src/pages/ADMIN/Position"))
const UserContact = React.lazy(() => import("src/pages/ADMIN/UserContact"))
const SchoolContact = React.lazy(() => import("src/pages/ADMIN/SchoolContact"))
const TeacherContact = React.lazy(() =>
  import("src/pages/ADMIN/TeacherContact"),
)
const BusinessContact = React.lazy(() =>
  import("src/pages/ADMIN/BusinessContact"),
)
const Skills = React.lazy(() => import("src/pages/ADMIN/Skills"))

const Role = React.lazy(() => import("src/pages/ADMIN/Role"))

function LazyLoadingComponent({ children }) {
  return (
    <React.Suspense
      fallback={
        <div className="loading-center" style={{ height: "100vh" }}>
          <Spin />
        </div>
      }
    >
      {children}
    </React.Suspense>
  )
}

const routes = [
  {
    path: ROUTER.SVG_VIEWER,
    element: (
      <LazyLoadingComponent>
        <SvgViewer />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.LOGIN_GOOGLE,
    element: (
      <LazyLoadingComponent>
        <LoginGoogle />
      </LazyLoadingComponent>
    ),
  },

  // ADMIN
  {
    element: (
      <LazyLoadingComponent>
        <AminRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.BANNER_FOOTER,
        element: (
          <LazyLoadingComponent>
            <BannerFooter />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.YEU_CAU_HO_TRO,
        element: (
          <LazyLoadingComponent>
            <RequestSupport />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.DANH_SACH_HOC_VIEN,
        element: (
          <LazyLoadingComponent>
            <StudentsList />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.QUAN_LY_KHOA_HOC,
        element: (
          <LazyLoadingComponent>
            <CourseManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.QUAN_LY_BAI_GIANG}/:id`,
        element: (
          <LazyLoadingComponent>
            <DetailCourse />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.DANH_SACH_DE_THI}`,
        element: (
          <LazyLoadingComponent>
            <Exams />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.NGAN_HANG_CAU_HOI}`,
        element: (
          <LazyLoadingComponent>
            <Questions />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.DANH_SACH_BAI_VIET,
        element: (
          <LazyLoadingComponent>
            <PostManager />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_MUC_THE_NGAN_HANG_DE,
        element: (
          <LazyLoadingComponent>
            <Tags />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_MUC_THE,
        element: (
          <LazyLoadingComponent>
            <Tags isPost={true} />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PHAN_QUYEN,
        element: (
          <LazyLoadingComponent>
            <Role />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.TONG_QUAT,
        element: (
          <LazyLoadingComponent>
            <Overview />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_BA_TRUONG_HOC,
        element: (
          <LazyLoadingComponent>
            <SchoolContact />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_BA_GIAO_VIEN,
        element: (
          <LazyLoadingComponent>
            <TeacherContact />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_BA_NHAN_VIEN,
        element: (
          <LazyLoadingComponent>
            <UserContact />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_BA_DOANH_NGHIEP,
        element: (
          <LazyLoadingComponent>
            <BusinessContact />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CHUC_VU,
        element: (
          <LazyLoadingComponent>
            <Position />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.KY_NANG,
        element: (
          <LazyLoadingComponent>
            <Skills />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.THONG_KE_TONG_QUAN,
        element: (
          <LazyLoadingComponent>
            <StatisticsOverview />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_CHI_TIET,
        element: (
          <LazyLoadingComponent>
            <Statistical />
          </LazyLoadingComponent>
        ),
      },
    ],
  },

  //  USER
  {
    element: (
      <LazyLoadingComponent>
        <PrivateRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.TONG_QUAN,
        element: (
          <LazyLoadingComponent>
            <Dashboard />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.TONG_QUAN}/:id`,
        element: (
          <LazyLoadingComponent>
            <Dashboard />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.HO_SO_CUA_TOI,
        element: (
          <LazyLoadingComponent>
            <ProfileManager />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.VAO_HOC}/:id`,
        element: (
          <LazyLoadingComponent>
            <LearnLesson />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.GIO_HANG,
        element: (
          <LazyLoadingComponent>
            <CardShopping />
          </LazyLoadingComponent>
        ),
      },
    ],
  },

  //  ANONYMOUS
  {
    element: (
      <LazyLoadingComponent>
        <PublicRouters />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.HOME,
        element: (
          <LazyLoadingComponent>
            <Home />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_KHOA_HOC,
        element: (
          <LazyLoadingComponent>
            <ListCourse />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.Tim_KIEM_KHOA_HOC,
        element: (
          <LazyLoadingComponent>
            <SearchCourse />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.CHI_TIET_KHOA_HOC}/:id`,
        element: (
          <LazyLoadingComponent>
            <CourseDetail />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.DANH_SACH_TIN_TUC}`,
        element: (
          <LazyLoadingComponent>
            <News />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.TIN_TUC}/:id`,
        element: (
          <LazyLoadingComponent>
            <NewsDetail />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.DANH_SACH_GIAO_VIEN}`,
        element: (
          <LazyLoadingComponent>
            <ListAllTeacher />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.THONG_TIN_GIAO_VIEN}/:id`,
        element: (
          <LazyLoadingComponent>
            <TeacherProfile />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.TIM_KIEM_TIN_TUC,
        element: (
          <LazyLoadingComponent>
            <Search />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <LazyLoadingComponent>
        <NotFound />
      </LazyLoadingComponent>
    ),
  },
]
const AppRouter = () => {
  const renderRouter = useRoutes(routes)
  return renderRouter
}
export default AppRouter
